import {
	ISSUE_LINKS_FIELDTYPE,
	type Field,
	type FieldId,
	type IssueLink,
} from '../../common/constants/fields';
import type { ColumnMap, Column, ColumnName } from '../../common/types';
import type { CSVData } from '../../common/utils/csv-import-clients/types';
import type { MappingStateWithSuggestedDateFormat } from './types';

export const transformToColumnsState = (columns: Column[]): ColumnMap => {
	const columnMap: ColumnMap = {};

	columns.forEach((column) => {
		columnMap[column.columnName] = {
			...column,
			isVisible: true,
			isIncluded: true,
		};
	});

	return columnMap;
};

export const transformToColumnOrder = (columns: Column[]): ColumnName[] =>
	columns.map((column) => column.columnName);

export const transformToMappedJiraFieldIds = (columns: Column[]): Set<FieldId> =>
	new Set(
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		columns.filter((col) => !!col.field?.fieldId).map((col) => col.field?.fieldId) as string[],
	);

export const transformToField = (availableIssueLinks: IssueLink[]): Field[] =>
	availableIssueLinks
		? availableIssueLinks.map((issueLink) => ({
				fieldName: issueLink.linkName,
				fieldType: ISSUE_LINKS_FIELDTYPE,
				fieldId: issueLink.linkId,
				fieldDirection: issueLink.linkDirection,
			}))
		: [];

export const transformToMappingStateWithSuggestedDateFormat = ({
	columns,
	rows,
	availableNewFieldTypes,
	availableJiraFields,
	availableIssueLinks,
	suggestedDateFormat,
}: CSVData): MappingStateWithSuggestedDateFormat => {
	const mappedJiraFieldIds = transformToMappedJiraFieldIds(columns);
	return {
		columnOrder: transformToColumnOrder(columns),
		columns: transformToColumnsState(columns),
		rows,
		availableNewFieldTypes,
		availableJiraFields,
		availableIssueLinkFields: transformToField(availableIssueLinks),
		mappedJiraFieldIds,
		validationError: null,
		suggestedDateFormat,
		selectedColumn: undefined,
		userMapping: null,
		shouldImportUsers: true,
		issueCount: null,
		errorsFilter: null,
		preMappedFieldCount: mappedJiraFieldIds.size,
		mappedLinkFieldsCount: 0,
		preFilledUsersCount: 0,
	};
};
